/**
 * Comp-code tag dictionary + deal-source resolution — EXACT port of v2.9
 * TAGS and resolveDealSource_ (docs/Payroll/PayrollAutomation_v2.gs).
 *
 * KNOWN PRESERVED DEFECT (D-27): SELF_SOURCED does not match the observed
 * "Self Soruced" transposition; fixing it is a versioned engine change.
 * Pure module — shared with the frontend bundle.
 */

const TAGS = {
  SELF_SOURCED: /self[\s-]*sou?rced|self[\s-]*gen(erated)?\b|\bSS\b/i,
  COMPANY_DEAL: /\bCD\b|company[\s-]*deal|company[\s-]*sourced/i,
  CORRESPONDENT: /\bcorr(espondent)?\b/i,
  HELOC: /heloc|heloan|hecm/i,
  EXPLICIT_BP: /\bBP\b|borrower[\s-]*paid/i,
  EXPLICIT_LP: /\bLP\b|lender[\s-]*paid/i,
  SUB2: /2nd\s*(lender\s*)?submission/i,
  SUB3: /3rd\s*(lender\s*)?submission/i,
  HANNAH_80BPS: /hannah\s*80\s*bps/i,
  FOSTER_NOTE: /Foster's split is \$([\d.]+)/,
  // Flag-only manual-adjustment tags (D-8 / D-7 pending):
  MANUAL_PATTERNS: [
    [/minus[^,;|]*insurance/i, 'INSURANCE_NOTE'],
    [/\bEPO\b/i, 'EPO_NOTE'],
    [/referr?al/i, 'REFERRAL_NOTE'],
    [/tolerance/i, 'TOLERANCE_NOTE'],
    [/floating|subject to change/i, 'FLOATING_PRICE'],
    [/minus/i, 'MANUAL_MINUS_NOTE'],
  ],
};

/**
 * Deal Source precedence: column → comp-code tags → plan default.
 * Exact port of v2.9 resolveDealSource_.
 */
function resolveDealSource(colValue, compCode, prof) {
  const v = String(colValue || '').trim().toUpperCase();
  if (/SELF/.test(v)) return { source: 'SELF', how: 'column' };
  if (/COMPANY|^CD$/.test(v)) return { source: 'COMPANY', how: 'column' };
  if (/BROKER|REFERRAL/.test(v)) return { source: 'BROKER_REF', how: 'column' };

  const hasCD = TAGS.COMPANY_DEAL.test(compCode);
  const hasSS = TAGS.SELF_SOURCED.test(compCode);
  if (hasCD && !hasSS) return { source: 'COMPANY', how: 'compcode' };
  if (hasSS && !hasCD) return { source: 'SELF', how: 'compcode' };
  if (hasCD && hasSS) return { source: 'COMPANY', how: 'conflict' };

  if (prof && prof.planType && prof.planType.indexOf('DTC') === 0) {
    return { source: 'COMPANY', how: 'assumed' }; // majority case; flagged by caller
  }
  return { source: 'SELF', how: 'default' };
}

module.exports = { TAGS, resolveDealSource };
